<template>
  <div>
    <notification-message
      v-if="!fromTeacher"
      iconClass="el-icon-check"
      :message="$t('school.setup_school.successfully_created')"
    />
    <div class="content">
      <onboarding-options-picker
        :options="pickerOptions"
        :title="$t('school.setup_school.setup_your_school')"
        :subtitle="!fromTeacher ? $t('school.setup_school.invite_students_teachers') : $t('school.setup_school.create_your_first_class')"
        :buttonText="$t('school.setup_school.continue')"
        @continueEvent="setupSchool"
      />
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/common/NotificationMessage'
  import OnboardingOptionsPicker from '@/components/common/OnboardingOptionsPicker'

  export default {
    components: {
      NotificationMessage,
      OnboardingOptionsPicker
    },
    props: {
      fromTeacher: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        pickerOptions: [
          {
            input: 'class',
            image: 'create-class.svg',
            name: this.$t('school.setup_school.create_class')
          },
          {
            input: 'teacher',
            image: 'teacher.svg',
            name: this.$t('school.setup_school.invite_teachers'),
            isVisible: !this.fromTeacher
          },
          {
            input: 'student',
            image: 'invite-students.svg',
            name: this.$t('school.setup_school.invite_students')
          }
        ]
      }
    },
    mounted() {
      // TODO: this need to be changed
      this.$store.dispatch('user/loadUserData')
    },
    methods: {
      setupSchool() {

      }
    },
  }
</script>

<style lang="scss" scoped>
  .content {
    display: table;
    margin: 0 auto;
    margin-top: 48px;
  }

</style>
